import './PublishedOn.scss'

import React from 'react'
import {Theme} from '../Theme'
import {style} from '../../util/style'
import {useTranslation} from '../../util/i18n'

const styles = style('publishedon')

const PublishedOn: React.FC<{date?: Date}> = ({date}) => {
	const t = useTranslation('news')

	if (!date) return null

	return (
		<div className={styles()}>
			<Theme.Container>
				{t.publishedOn}{' '}
				<time dateTime={date.toISOString()}>
					{date.toLocaleDateString('nl-BE', {
						year: 'numeric',
						month: 'long',
						day: 'numeric'
					})}
				</time>
			</Theme.Container>
		</div>
	)
}

export default PublishedOn
